<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Nom et Postnom</label>
        <label class="input-group-text"></label>
      </div>
      <input v-model="dataForm.nom"
             class="form-control"
             name="staff_nom"
             placeholder="Entrez le nom du membre des staffs"
             type="text">
      <input v-model="dataForm.postnom"
             class="form-control"
             name="staff_postnom"
             placeholder="Entrez le postnom du membre des staffs"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Prenom</label>
      </div>
      <input v-model="dataForm.prenom"
             class="form-control"
             name="staff_prenom"
             placeholder="Entrez le prénom du membre des staffs"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Nationalité</label>
      </div>
      <select v-model="dataForm.nationalite"
              class="custom-select"
              name="staff_nationalite">
        <option :value="dataForm.nationalite">{{ dataForm.nationalite }}</option>
        <option :value="dataForm.nationalite">-------------------------------------</option>
        <option :key="'nationalite'+idx"
                :value="nationalite.value"
                v-for="(nationalite, idx) in getNationalites">{{ nationalite.nationalites }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Equipe actuelle</label>
      </div>
      <select v-model="dataForm.equipe_id"
              class="custom-select"
              name="staff_equipe_actuelle">
        <option :value="staff.equipe_id">
          {{
          equipes ? equipes.filter((equipe) => equipe.equipe_id === staff.equipe_id)[0].nom : ''
          }}
        </option>
        <option :value="staff.equipe_id">-------------------------------------</option>
        <option :key="equipe.equipe_id.slice(5,15)"
                :value="equipe.equipe_id"
                v-for="equipe in equipes">
          {{ equipe.nom }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Fonction</label>
      </div>
      <select v-model="dataForm.fonction"
              class="custom-select"
              name="staff_fonction">
        <option :value="staff.fonction">{{ staff.fonction }}</option>
        <option :value="staff.fonction">-------------------------------------</option>
        <option :key="fonction"
                :value="fonction"
                v-for="fonction in getFonctionsStaff">
          {{ fonction }}
        </option>
      </select>
    </div>
    <!--
        <div class="input-group-sm input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="staff_equipes_passees">Equipes passées</label>
          </div>
          <select id="staff_equipes_passees"
                  v-model="dataForm.equipes_passees_id"
                  class="custom-select"
                  multiple
                  name="staff_equipes_passees">
            <option :key="equipe.equipe_id.slice(0,10)"
                    :value="equipe.equipe_id"
                    v-for="equipe in equipes">
              {{ equipe.nom }}
            </option>
          </select>
        </div>
    -->
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Date de naissance</label>
      </div>
      <input v-model="dataForm.date_naissance"
             class="form-control"
             name="staff_date_naissance"
             type="date">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Date début et fin du contrat</label>
        <label class="input-group-text"></label>
      </div>
      <input v-model="dataForm.date_debut_contrat"
             class="form-control"
             name="staff_date_debut_contrat"
             type="date">
      <input v-model="dataForm.date_fin_contrat"
             class="form-control"
             name="staff_date_fin_contrat"
             type="date">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Photo passeport</label>
      </div>
      <input ref="fileToUpload"
             @change="handleFileToUpload"
             lang="fr"
             type="file"
             class="form-control"
             accept=".png, .jpeg, .jpg">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Historique</label>
      </div>
      <textarea v-model="dataForm.historique"
                class="form-control"
                name="staff_historique"
                placeholder="Entrez un bref historique du membre des staffs">
      </textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Telephones</label>
        <label class="input-group-text"></label>
      </div>
      <input v-model="dataForm.telephones"
             class="form-control"
             name="staff_telephone_1"
             placeholder="Entrez le numéro prncipal du staff"
             type="tel">
      <input v-model="dataForm.telephones"
             class="form-control"
             name="staff_telephone_2"
             placeholder="Entrez le numéro secondaire du staff"
             type="tel">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Email</label>
      </div>
      <input v-model="dataForm.email"
             class="form-control"
             name="staff_email"
             placeholder="Entrez l'adresse email du staff"
             type="email">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="form-check form-check-inline">
        <input class="form-check-input"
               type="radio"
               v-model="dataForm.sexe"
               name="staff_sexe"
               value="homme">
        <label class="form-check-label rounded pl-2 pr-2">Homme</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input"
               type="radio"
               v-model="dataForm.sexe"
               name="staff_sexe"
               value="femme">
        <label class="form-check-label rounded pl-2 pr-2">Femme</label>
      </div>
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Update",
  props: {
    staff: {
      type: Object
    }
  },
  data() {
    return {
      equipes: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        nom: '',
        postnom: '',
        prenom: '',
        nationalite: '',
        equipe_id: '',
        equipes_passees_id: '[]',
        fonction: '',
        date_naissance: '',
        date_debut_contrat: '',
        date_fin_contrat: '',
        photo_passeport: '',
        historique: '',
        description: '',
        commentaires: '',
        telephones: '',
        email: '',
        sexe: '',
        table: 'staffs',
        table_id: this.staff.staff_id,
      },
      file: '',
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
      location.reload(false)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPutData',
      'axiosPostFileData',
    ]),
    handleFileToUpload(){
      this.file = this.$refs.fileToUpload.files[0];
    },
    uploadFile () {
      let formData = new FormData()
      let fileName = ''
      if(this.dataForm.nom && this.dataForm.postnom && this.dataForm.prenom){
        fileName = this.dataForm.prenom.toLowerCase() + '_' +
            this.dataForm.postnom.toLowerCase() + '_' +
            this.dataForm.nom.toLowerCase() + '_' + Math.floor(Math.random() * 1000000) + 1
      }
      formData.append('fileToUpload', this.file)
      formData.append('fileName', fileName)
      formData.append('to', "staffs")
      this.axiosPostFileData(formData)
        .then(data => {
          this.dataForm.photo_passeport = data[2];
          this.resetDefaultValues()
          if(!this.dataForm.photo_passeport)
            this.dataForm.photo_passeport = this.staff.photo_passeport
          this.axiosPutData(this.dataForm)
            .then((data) => {
              if(data.status === 204)
                this.messageSuccess = "Membre du staff modifié avec succès !"
              else
                this.messageFailure = "Une erreur est survenue lors de la modification du membre de staff !"
            })
            .catch((error) => {
              this.messageFailure = "Une erreur est survenue lors de la modification du membre de staff !"
            })
        })
        .catch(data => {})
    },
    onSubmit() {
      this.uploadFile()
    },
    resetDefaultValues() {
      if(this.dataForm.nom === '')
        this.dataForm.nom = this.staff.nom
      if(this.dataForm.postnom === '')
        this.dataForm.postnom = this.staff.postnom
      if(this.dataForm.prenom === '')
        this.dataForm.prenom = this.staff.prenom
      if(this.dataForm.nationalite === '')
        this.dataForm.nationalite = this.staff.nationalite
      if(this.dataForm.equipe_id === '')
        this.dataForm.equipe_id = this.staff.equipe_id
      if(this.dataForm.equipes_passees_id === '')
        this.dataForm.equipes_passees_id = this.staff.equipes_passees_id
      if(this.dataForm.fonction === '')
        this.dataForm.fonction = this.staff.fonction
      if(this.dataForm.date_naissance === '')
        this.dataForm.date_naissance = this.staff.date_naissance
      if(this.dataForm.date_debut_contrat === '')
        this.dataForm.date_debut_contrat = this.staff.date_debut_contrat
      if(this.dataForm.date_fin_contrat === '')
        this.dataForm.date_fin_contrat = this.staff.date_fin_contrat
      if(this.dataForm.photo_passeport === '')
        this.dataForm.photo_passeport = this.staff.photo_passeport
      if(this.dataForm.historique === '')
        this.dataForm.historique = this.staff.historique
      if(this.dataForm.telephones === '')
        this.dataForm.telephones = this.staff.telephones
      if(this.dataForm.email === '')
        this.dataForm.email = this.staff.email
      if(this.dataForm.sexe === '')
        this.dataForm.sexe = this.staff.sexe
    },
    setDefaultValues() {
      const staff = Object.assign({}, this.staff);
      this.dataForm.nom = staff.nom
      this.dataForm.postnom = staff.postnom
      this.dataForm.prenom = staff.prenom
      this.dataForm.nationalite = staff.nationalite
      this.dataForm.equipe_id = staff.equipe_id
      this.dataForm.equipes_passees_id = staff.equipes_passees_id
      this.dataForm.fonction = staff.fonction
      this.dataForm.date_naissance = staff.date_naissance
      this.dataForm.date_debut_contrat = staff.date_debut_contrat
      this.dataForm.date_fin_contrat = staff.date_fin_contrat
      this.dataForm.photo_passeport = staff.photo_passeport
      this.dataForm.historique = staff.historique
      this.dataForm.telephones = staff.telephones
      this.dataForm.email = staff.email
      this.dataForm.sexe = staff.sexe
    }
  },
  computed: {
    ...mapGetters([
      'getNationalites',
      'getFonctionsStaff',
    ])
  },
  beforeCreate() {
  },
  created() {
    this.setDefaultValues()
    //
    this.axiosGetAllData({
      table: 'equipes'
    })
        .then((data) => {
          this.equipes = data.data
        })
        .catch((data) => {
          this.equipes = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/staffs/components/Update.vue